import { render, staticRenderFns } from "./ChartsPanel.vue?vue&type=template&id=49fd9edd&scoped=true"
import script from "./ChartsPanel.vue?vue&type=script&lang=js"
export * from "./ChartsPanel.vue?vue&type=script&lang=js"
import style0 from "./ChartsPanel.vue?vue&type=style&index=0&id=49fd9edd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd9edd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GlobalChart: require('/home/vsts/work/1/s/components/global/Chart.vue').default})
